import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { UpdateUserDto, UserNoPasswordNoRelations } from 'types';
import { useAppDispatch } from 'app/hooks';
import { setUserSettings } from 'features/auth/authSlice';

export const updateUser = async ({
  data,
  userId,
}: {
  data: UpdateUserDto;
  userId: number;
}): Promise<UserNoPasswordNoRelations> => {
  const response = await axios.put(`/api/users/${userId}`, data);
  return response.data as UserNoPasswordNoRelations;
};

type UseUpdateUserOptions = {
  config?: MutationConfig<typeof updateUser>;
};

export const useUpdateUser = ({ config }: UseUpdateUserOptions = {}) => {
  const dispatch = useAppDispatch();
  return useMutation({
    onSuccess: (data: UserNoPasswordNoRelations) => {
      queryClient.refetchQueries(['user', data.id]);
      queryClient.invalidateQueries(['users']);
      if (data.us_customary_units !== undefined)
        dispatch(
          setUserSettings({ us_customary_units: data.us_customary_units })
        );
      if (data.timezone !== undefined)
        dispatch(setUserSettings({ timezone: data.timezone }));
      if (data.twenty_four_hour_time !== undefined)
        dispatch(
          setUserSettings({ twenty_four_hour_time: data.twenty_four_hour_time })
        );
      if (data.date_format !== undefined)
        dispatch(setUserSettings({ date_format: data.date_format }));
      if (data.alarm_popups !== undefined)
        dispatch(setUserSettings({ alarm_popups: data.alarm_popups }));
    },
    ...config,
    mutationFn: updateUser,
  });
};
